import { combineReducers } from "redux";
import tickets from "./ticketsReducer";

const reducers = combineReducers({
  tickets,
});

export default reducers;
